import { Plus } from "lucide-react";
import React from "react";

import { IgButton } from "@intelligems/ig-theme/IgButton";
import { IgTooltip } from "@intelligems/ig-theme/IgTooltip";
import Grid from "@mui/material/Grid";

interface AddAnotherButtonProps {
  onAddClick: () => void;
  itemLabel: string;
  isDisabled?: boolean;
}

export const AddAnotherButton = ({
  onAddClick,
  itemLabel,
  isDisabled,
}: AddAnotherButtonProps) => {
  return (
    <Grid width={"fit-content"}>
      <IgTooltip
        title={isDisabled ? "A maximum of 5 URL conditions can be added" : ""}
      >
        <IgButton
          startIcon={<Plus size={16} />}
          variant={"text"}
          sx={{
            width: "100%",
          }}
          onClick={onAddClick}
          disabled={isDisabled}
        >
          {itemLabel}
        </IgButton>
      </IgTooltip>
    </Grid>
  );
};
